import { accessoriesMacro } from "@/mocks/techData";

const steps = [
  { key: "cable", title: "The Cable", caption: "Braided, durable, built to last." },
  { key: "connector", title: "The Connector", caption: "Precise, secure, ready to go." },
  { key: "charging", title: "The Charge", caption: "Fast, reliable, everyday." },
];

export default function AccessoriesSection() {
  return (
    <section id="accessories" className="bg-foreground-100 py-20 md:py-28">
      <div className="container-x">
        <div className="mb-10 max-w-2xl md:mb-14">
          <p className="eyebrow mb-4 flex items-center gap-3">
            <span className="inline-block h-px w-8 bg-foreground-950"></span>
            The Details
          </p>
          <h2 className="section-title">
            The details <span className="text-primary-600">matter.</span>
          </h2>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-600">
            From chargers and cables to cases and speakers — the accessories that keep your everyday
            tech powered, protected and ready.
          </p>
        </div>

        <div className="grid gap-4 md:grid-cols-3 md:gap-5">
          {steps.map((s, i) => (
            <figure
              key={s.key}
              className="group relative overflow-hidden rounded-lg bg-foreground-950"
            >
              <div className="aspect-[4/3] md:aspect-[4/5]">
                <img
                  src={accessoriesMacro[s.key as keyof typeof accessoriesMacro]}
                  alt={`${s.title} — charging accessory from Fist Limited in Liverpool`}
                  className="h-full w-full object-cover transition-transform duration-[900ms] group-hover:scale-105"
                />
              </div>
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/90 to-transparent p-5">
                <div className="flex items-center gap-3">
                  <span className="font-heading text-2xl text-primary-400">0{i + 1}</span>
                  <div>
                    <p className="font-heading text-base text-background-50">{s.title}</p>
                    <p className="mt-0.5 text-xs text-background-100/70">{s.caption}</p>
                  </div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-start gap-4 rounded-lg bg-foreground-950 p-6 md:flex-row md:items-center md:justify-between md:p-8">
          <div className="max-w-xl">
            <h3 className="font-heading text-xl text-background-50 md:text-2xl">
              Everyday accessories, ready when you are.
            </h3>
            <p className="mt-2 text-sm text-background-100/70">
              Chargers, cables, cases, headsets and speakers — quality essentials without the premium
              mark-up.
            </p>
          </div>
          <a href="#categories" className="btn-primary h-11 shrink-0 px-5 text-xs">
            Explore Accessories <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}